// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3Fx4i","upload":"Small_upload__3JX59","imageWrap":"Small_imageWrap__3aEJI","removeBtn":"Small_removeBtn__1lowe"};